import React from 'react';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Alert, Typography, Container, Box, Link, Divider } from '@mui/material';
import { AppContext } from '/@/app/AppContext';
import { Outlet } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import { route } from '/@/app/routes';
import { Spinner } from '/@/app/components/Spinner';
import { HelpingDrawerLayout } from '/@/app/views/common/HelpingDrawerLayout';

import { useApi} from '/@/app/Api';
import { freeMeasurementsViewState, injectApi } from '/@/app/views/FreeMeasurementsView/FreeMeasurementsViewState';
import { TableOfContents } from '/@/app/views/FreeMeasurementsView/TableOfContents';
import { ActionDialog } from '/@/app/views/FreeMeasurementsView/ActionDialog';

export const FreeMeasurementsView = () => {
    const api=useApi();
    const { userData, featureEnabled } = useContext(AppContext);

    if (!featureEnabled('free_measurements')) {
        return (
            <Container>
                <Box>
                    <Typography variant="h4">Произвольные измерения</Typography>
                    <Alert severity="warning" sx={{ mt: 3 }}>
                        Ваш аккаунт не имеет доступа к произвольным измерениям.
                    </Alert>
                </Box>
            </Container>
        )
    }

    injectApi(api);
    freeMeasurementsViewState.firstLoad(userData.id);
    // Bind the component to static state.
    return (
        <_FreeMeasurementsView state={freeMeasurementsViewState} />
    );
}


const _FreeMeasurementsView = observer(({ state }) => {
    if (state.sections.length === 0) {
        return (
            <Container sx={{ mt: 4, textAlign: "center" }}>
                <Spinner size={60} />
            </Container>
        );
    }

    const DrawerContent = ({ drawerOpen, setDrawerOpen }) => {
        return <TableOfContents closeDrawer={() => setDrawerOpen(false)} />
    };

    return (
        <HelpingDrawerLayout
            drawerContent={DrawerContent}
            buttonText="Разделы"
            // customized smaller sidebar
            sidebarWidth={{ xs: "0", lg: "300px" }}
            drawerWidth={{ xs: "100vw", sm: "300px" }}
        >
            <Container maxWidth="md" sx={{
                p: { xs: "0!important" }, // fit the diagrams to the full width
            }}>
                {/* SubViewNavigator - subpath view */}
                <Outlet />
            </Container>
            {/* Common dialog for all Add/Change/Delete actions, bound to global actionDialogState */}
            <ActionDialog />
        </HelpingDrawerLayout>
    );
});
